var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="survey-item__title">\n  '+
((__t=( title ))==null?'':_.escape(__t))+
'\n</div>\n<div class="survey-item__options"></div>\n';
}
return __p;
};
